import * as ko from "knockout";
import labels from "app/labels";

export class taskStep {
  task_status: KnockoutObservable<string>;
  next_step_description: KnockoutObservable<string>;
  next_step_message_id: KnockoutObservable<string>;
  status_change: KnockoutObservable<string>;
  next_activity_change: KnockoutObservable<string>;
  message_id: KnockoutObservable<string>;
  refresh_in: KnockoutObservable<number>;
  send_person_id: KnockoutObservable<boolean>;

  constructor(item?: any) {
    this.task_status = ko.observable(item?.task_status);
    this.next_step_description = ko.observable(item?.next_step_description);
    this.message_id = ko.observable(labels.descr(item?.next_step_message_id));
    this.next_step_message_id = ko.observable(item?.next_step_message_id);
    this.status_change = ko.observable(item?.status_change);
    this.next_activity_change = ko.observable(item?.next_activity_change);
    this.refresh_in = ko.observable(!isNaN(parseInt(item?.refresh_in, 10)) ? parseInt(item?.refresh_in, 10) * 1000 : 0);
    this.send_person_id = ko.observable(item?.send_person_id ? item?.send_person_id : "N");
  }
}
